module.exports = __webpack_public_path__ + "img/interrogacao.f05e9193.svg";